<template>
  <div>
    <div class="h_b"
         :style="{'backgroundColor':data.bg}"
         v-for="x in 1"
         :key="x">
      <div class="curriculum_top">
        <div class="curriculum_title">
          <!-- 实操基地活动回顾 -->
          <!-- <span style="margin-left:20px;font-size:14px">介绍内容</span>
          <span class="tabItem"
                v-for="h in 6"
                :key="h +'h'">{{h}}</span> -->
        </div>
        <!-- <div>更多</div> -->
      </div>
      <!-- <el-empty v-if="data.records.length==0"
                style="width: 100%;"
                description="暂无案例"></el-empty> -->
      <div class="curriculum_list"
           v-if="data && data.records && data.records.length!=0">
        <div class="curriculum_item"
             :style="{'backgroundColor':data.itembg,'width':'calc((100% - 60px) /'+ 3 +')'}"
             v-for="(item,index) in data.records"
             @click="toDetails(item)"
             :key="index">
          <div class="img">
            <el-image class="dong"
                      style="width:100%; height: 244px;border-radius: 10px 10px 0 0;"
                      :src="item.pictureUrl"></el-image>
          </div>
          <div class="curriculum_item_box">
            <div class="curriculum_item_title font18"
                 v-if="item.titleName && item.titleName!=''">{{item.titleName.length>35?item.titleName.slice(0,34)+'...':item.titleName}}</div>
            <div class="lecturer"
                 v-if="item.titleTwoName && item.titleTwoName!=''">{{item.titleTwoName.length>35?item.titleTwoName.slice(0,34)+'...':item.titleTwoName}}</div>
            <div class="flexStart mainColor font14"
                 style="margin-top:24px">
              查看详情<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else
                style="width: 100%;"
                description="暂无案例"></el-empty>
      <div v-if="data.status == 'paging' && data.records && data.records.length!=0"
           class="flexCenter"
           style="margin-bottom: 20px;">
        <el-pagination background
                       @current-change="currentChange"
                       layout="prev, pager, next"
                       :page-size="data.size"
                       :total="data.total">
        </el-pagination>
      </div>
      <div v-if="data.records && data.records.length!=0 && data.status == 'more'"
           class="flexCenter"
           style="color:#DE1F26;font-size:16px;padding-bottom: 20px;cursor: pointer;"
           @click="toList">
        更多案例内容<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i>
        <!-- <i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i> -->
      </div>
    </div>
    <videoModal v-if="videoShow"
                ref="videoModal"
                @close="closeModal"></videoModal>
  </div>
</template>
<script>
import videoModal from '@/components/video/videoModal.vue'
import { articleClick } from '@/api/api.js'
export default {
  components: { videoModal },
  props: {
    data: {
      type: Object,
      default: {
        return: { list: [], total: 0, bg: '#f5f5f5', itembg: '#fff', status: 'more' }
      }
    },
  },
  data () {
    return {
      videoShow: false,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800'
    }
  },
  methods: {
    closeModal () {
      this.videoShow = false;
    },
    toDetails (item) {
      articleClick(item.id).then(res => {
        if (res && res.code == 200) {
          if (item.contentType == '1') {
            this.$router.push('/Article?articleId=' + item.id + '&articleClassify=' + item.articleClassify)
          } else if (item.contentType == '2') {
            this.videoShow = true;
            this.$nextTick(() => {
              this.$refs.videoModal.init(item)
            })
          } else if (item.contentType == '3') {
            window.open(item.contentText)
          }
        }
      })
      // this.$router.push('/Article?articleId=' + item.id + '&articleClassify=' + item.articleClassify)
    },
    toList () {
      this.$router.push('/Screen?type=article')
    },
    currentChange (e) {
      console.log(e)
      this.$emit('currrntChange', e)
    },
  }
}
</script>
<style lang="less" scoped>
.h_b {
  // background-color: #fff;
  margin-top: 20px;
  width: 1200px;
  .curriculum_top {
    display: flex;
    .curriculum_title {
      flex: 1;
      .tabItem {
        display: inline-block;
        margin: 0 20px;
      }
    }
  }
  .curriculum_list {
    width: 100%;
    display: flex;
    margin: 20px 0;
    flex-wrap: wrap;
    .curriculum_item:hover {
      bottom: 20px;
    }
    .curriculum_item {
      transition: all 4s ease-in-out;
      // flex: 1;
      cursor: pointer;
      border-radius: 10px;
      margin-right: 30px;
      background-color: #f6f6f6;
      margin-bottom: 30px;
      .img {
        width: 100%;
        height: 244px;
        overflow: hidden;
        .dong {
          transition: all 1.5s;
        }
        .dong:hover {
          transform: scale(1.2);
          border-radius: 10px 10px 0 0;
        }
      }
      .curriculum_item_box {
        padding: 20px 10px;
        box-sizing: border-box;
        .lecturer {
          color: #666666;
          font-size: 12px;
        }
        .curriculum_item_center {
          display: flex;
          margin: 15px 0;
          .l {
            background-color: #f2f4f7;
            color: '#333333';
            font-size: 12px;
            padding: 6px 8px;
            box-sizing: border-box;
            border-radius: 12px;
            margin-right: 10px;
          }
        }
        .curriculum_item_title {
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          font-size: 14px;
          color: #333;
          font-weight: bold;
        }
      }
    }
    .curriculum_item:nth-child(3) {
      margin-right: 0;
    }
    .curriculum_item:nth-child(6) {
      margin-right: 0;
    }
    .curriculum_item:nth-child(9) {
      margin-right: 0;
    }
    .curriculum_item:nth-child(12) {
      margin-right: 0;
    }
  }
}
</style>